import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import _, { chain, partial, split, isEmpty, toPlainObject } from 'lodash';

import { routes } from '../../routes';
import {
    MODAL_TYPE_LOGIN_FAILED,
    MODAL_TYPE_ENROLL,
    MODAL_TYPE_LOGGED_OUT,
    MODAL_TYPE_GIVEAWAY,
    MODAL_TYPE_GIVEAWAY_END,
    MODAL_TYPE_TREES_PAYMENT_MODAL
} from '../../services/modal/constants';
import { PATH } from '../../constants/path';
import { STATIC_RESOURCES_ROOT } from '../../constants';
import { LOCALES, DEFAULT_LOCALE } from '../../constants/locale';
import { COOKIE_KEY_REDIRECT_AFTER_LOGIN } from '../../constants/cookie';

import {
    canShowContestEndModal,
    canShowContestModal,
    handleContestCookie,
    handleContestEndCookie,
    isContestActive
} from '../../services/giveaway/utils';
import {
    canShowTreesPaymentModal,
    handleTreesPaymentCookie
} from '../../services/modal/TreesPaymentModal/utils';
import { getClientUrl } from '../../utils/ssoUtil';
import { mapRoutes } from '../../utils/routeUtils';
import { getLocaleFromRoutes } from '../../services/i18n/utils';
import { initNewsletterBypass, isNewsletterBypassActive } from '../../utils/newsletterReferer';

import {
    registerAdBlockerDetection,
    registerCookieDetection
} from '../../services/adblocker/actions';
import { showModal } from '../../services/modal/actions';
import { fetchEbonPartners } from '../../services/ebon/actions';
import { changeCurrentLocale } from '../../services/i18n/actions';
import { fetchPartnersIfNeeded } from '../../services/partner/actions';
import { fetchCategoriesIfNeeded } from '../../services/category/actions';
import { logoutUser } from '../../services/authentication/logout/actions';
import { loginUser } from '../../services/authentication/login/actions';
import { fetchContestIfNeeded, isUserRegisteredToContest } from '../../services/giveaway/actions';

const ConnectedSwitch = connect(state => ({
    location: state.location
}))(Switch);

class RouterComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { checkLogin: false };
    }

    componentWillMount() {
        this.changeCurrentLocaleIfNeeded(this.props);
        const {
            location: { search, pathname },
            loginUser,
            logoutUser,
            isAuthed,
            isAuthFetching,
            history,
            showModal,
            modalType
        } = this.props;

        const values =
            search &&
            chain(search)
                .replace('?', '') // a=b454&c=dhjjh&f=g6hksdfjlksd
                .split('&') // ["a=b454","c=dhjjh","f=g6hksdfjlksd"]
                .map(partial(split, _, '=', 2)) // [["a","b454"],["c","dhjjh"],["f","g6hksdfjlksd"]]
                .fromPairs() // {"a":"b454","c":"dhjjh","f":"g6hksdfjlksd"}
                .value();

        const token = values && values.tk;
        const loginState = values && values.login;
        const temporary = values && values.tp;

        initNewsletterBypass(pathname, search);

        if (token) {
            if (isAuthed) {
                const callback = new RegExp(PATH.ACCOUNT_PATH).test(pathname)
                    ? () => history.push(PATH.HOME_PATH)
                    : null;
                logoutUser(callback);
            }

            loginUser({ token }, () => {
                history.push(pathname);
                if (sessionStorage.getItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN)) {
                    history.push(sessionStorage.getItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN));
                    sessionStorage.removeItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN);
                }
            });
        }

        if (temporary) {
            if (isAuthed) {
                const callback = new RegExp(PATH.ACCOUNT_PATH).test(pathname)
                    ? () => history.push(PATH.HOME_PATH)
                    : null;
                logoutUser(callback);
            }

            history.push(pathname);
            showModal(MODAL_TYPE_ENROLL, {
                id: 'enroll-modal',
                uuid: temporary,
                actionOnClose: this.logoutOnClose
            });
        }

        if (loginState) {
            if (isAuthed) {
                const callback = `/${PATH.ACCOUNT_PATH}`.test(pathname)
                    ? () => history.push('/')
                    : null;
                logoutUser(callback);
            }
            history.push(pathname);

            showModal(MODAL_TYPE_LOGIN_FAILED, {
                id: 'login-failed',
                actionOnClose: () => {
                    window.location = getClientUrl();
                },
                loginState: Number(loginState)
            });
        }

        // Check if user is currently enrolling, logging, is logged or has a modal displayed
        // If not, redirect user to login form on client side
        if (
            !token &&
            !temporary &&
            !loginState &&
            !isAuthFetching &&
            !isAuthed &&
            !modalType &&
            !new RegExp(PATH.UNSUBSCRIBE_PATH).test(pathname) &&
            !new RegExp(PATH.ERROR_PATH).test(pathname) &&
            !isNewsletterBypassActive(pathname)
        ) {
            showModal(MODAL_TYPE_LOGGED_OUT, {
                id: 'logged-out-modal',
                hideCloseButton: true,
                actionOnClose: () => {
                    window.location = getClientUrl();
                }
            });
        }

        this.detectAdBlocker();
        this.checkCookies();
    }

    componentDidMount() {
        const {
            fetchPartnersIfNeeded,
            fetchCategoriesIfNeeded,
            fetchEbonPartners,
            fetchContestIfNeeded
        } = this.props;

        fetchPartnersIfNeeded();
        fetchCategoriesIfNeeded();
        fetchEbonPartners();
        fetchContestIfNeeded();

        setTimeout(() => {
            this.setState({ checkLogin: true });
        }, 200);
    }

    componentWillReceiveProps(nextProps) {
        const {
            location,
            isAuthed,
            modalType,
            showModal,
            location: { pathname }
        } = this.props;
        const { checkLogin } = this.state;

        if (nextProps.location !== location) {
            this.changeCurrentLocaleIfNeeded(nextProps);
        }

        // Check if user is logged in
        if (
            checkLogin &&
            !modalType &&
            !nextProps.modalType &&
            !isAuthed &&
            !new RegExp(PATH.UNSUBSCRIBE_PATH).test(pathname) &&
            !new RegExp(PATH.ERROR_PATH).test(pathname) &&
            !isNewsletterBypassActive(nextProps.location.pathname)
        ) {
            showModal(MODAL_TYPE_LOGGED_OUT, {
                id: 'logged-out-modal',
                hideCloseButton: true,
                actionOnClose: () => {
                    window.location = getClientUrl();
                }
            });
        }

        /*
            When going back from Scellius form to merchant card using Browser'back button,
            Scellius scripts are not reloading themselves, which cause invalid cart amount
            on form the next time. For now, we reload the page to force the scripts to reset.
         */
        if (
            location.pathname.includes(PATH.EBON_VALIDATION_PATH) &&
            nextProps.location.pathname.includes(PATH.MERCHANTPAGE_EBON_PATH)
        ) {
            window.location = nextProps.location.pathname;
        }
    }

    componentDidUpdate(prevProps) {
        const {
            isAuthed,
            isUserRegisteredToContest,
            contest,
            showModal,
            registered,
            registeredFetching,
            modalType
        } = this.props;

        // Modale jeu concours
        if (
            isAuthed &&
            contest &&
            isContestActive(contest) &&
            registered === null &&
            !registeredFetching
        ) {
            isUserRegisteredToContest(contest.id);
        }
        if (
            isAuthed &&
            contest &&
            !modalType &&
            isContestActive(contest) &&
            prevProps.registered === null &&
            registered !== null &&
            !registered &&
            canShowContestModal(contest)
        ) {
            showModal(MODAL_TYPE_GIVEAWAY, {
                id: 'giveaway-modal',
                hideCloseButton: false,
                actionOnClose: () => {
                    handleContestCookie(contest);
                }
            });
        }

        // Modale fin de jeu concours
        if (isAuthed && !modalType && canShowContestEndModal()) {
            showModal(MODAL_TYPE_GIVEAWAY_END, {
                id: 'giveaway-end-winners-modal',
                hideCloseButton: false,
                actionOnClose: () => {
                    handleContestEndCookie();
                }
            });
        }

        // Modale plantation arbres
        if (isAuthed && !modalType && canShowTreesPaymentModal()) {
            showModal(MODAL_TYPE_TREES_PAYMENT_MODAL, {
                id: 'trees-payment-modal',
                hideCloseButton: false,
                actionOnClose: () => {
                    handleTreesPaymentCookie();
                }
            });
        }
    }

    changeCurrentLocaleIfNeeded({ pathname, currentLocale }) {
        // On vient mettre à jour le store si on arrive avec une url d'un autre langage
        const newLocale = getLocaleFromRoutes(pathname, LOCALES, DEFAULT_LOCALE);

        if (newLocale !== currentLocale) {
            this.props.changeCurrentLocale(newLocale);
            moment.locale(newLocale);
        }
    }

    logoutOnClose = () => {
        const { pathname, history, logoutUser } = this.props;
        const callback = /\/compte/.test(pathname) ? () => history.push('/') : null;

        logoutUser(callback);
    };

    detectAdBlocker() {
        const { registerAdBlockerDetection } = this.props;

        const head = document.getElementsByTagName('head')[0];

        const noAdBlockDetected = () => {
            registerAdBlockerDetection(false);
        };
        const adBlockDetected = () => {
            registerAdBlockerDetection(true);
        };

        // we will dynamically generate some 'bait'.
        const script = document.createElement('script');
        script.id = 'adblock-detection';
        script.type = 'text/javascript';
        script.src = `${STATIC_RESOURCES_ROOT}/scripts/adframe.js`;
        script.onload = noAdBlockDetected;
        script.onerror = adBlockDetected;

        head.appendChild(script);

        // clean up stale bait
        const oldScript = document.getElementById('adblock-detection');
        if (oldScript) {
            head.removeChild(oldScript);
        }
    }

    checkCookies() {
        const { registerCookieDetection } = this.props;

        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
        }

        registerCookieDetection(cookieEnabled);
    }

    render() {
        return <ConnectedSwitch>{mapRoutes(routes)}</ConnectedSwitch>;
    }
}

const mapStateToProps = state => {
    return {
        pathname: state.routing.location.pathname,
        locale: state.i18n.locale,
        isAuthed: !isEmpty(state.authentication.token),
        isAuthFetching: state.authentication.fetching,
        user: toPlainObject(state.account.user),
        modalType: state.modal.modalType,
        contest: state.giveaway.contest,
        registered: state.giveaway.registered,
        registeredFetching: state.giveaway.registeredFetching
    };
};

const mapDispatchToProps = {
    fetchPartnersIfNeeded,
    fetchEbonPartners,
    fetchCategoriesIfNeeded,
    fetchContestIfNeeded,
    changeCurrentLocale,
    loginUser,
    logoutUser,
    showModal,
    registerAdBlockerDetection,
    registerCookieDetection,
    isUserRegisteredToContest
};

export default connect(mapStateToProps, mapDispatchToProps)(RouterComponent);



// WEBPACK FOOTER //
// ./src/components/router/RouterComponent.js